var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatarActivatedTeam = function SvgDefaultAvatarActivatedTeam(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 19.7369C15.4 20.7455 11.9526 23.0001 7.69999 23.0001C3.4474 23.0001 0 20.7455 0 19.7369C0 14.6908 3.4474 10.6001 7.69999 10.6001C11.9526 10.6001 15.4 14.6908 15.4 19.7369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7383 11.1818C15.1272 13.0301 16.7279 16.2166 16.7833 19.6284C19.458 19.2542 21.4426 17.9506 21.4426 17.3151C21.4426 13.5793 18.7026 10.5509 15.3226 10.5509C14.6073 10.5509 13.9207 10.6865 13.2826 10.9358C13.0969 11.0083 12.9153 11.0905 12.7383 11.1818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0039 10.8316C21.6673 12.1371 22.7787 14.3684 22.814 16.7553C24.7371 16.5083 26.1744 15.571 26.1744 15.1175C26.1744 12.4909 24.2479 10.3616 21.8714 10.3616C21.3685 10.3616 20.8857 10.4569 20.4371 10.6322C20.2888 10.6901 20.1442 10.7568 20.0039 10.8316Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2019 3.6588C11.2019 6.79491 9.59017 9.93102 7.60195 9.93102C5.61373 9.93102 4.00195 6.79491 4.00195 3.6588C4.00195 1.6381 5.61373 0 7.60195 0C9.59017 0 11.2019 1.6381 11.2019 3.6588Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6808 5.27966C17.6808 7.40524 16.5884 9.53083 15.2408 9.53083C13.8932 9.53083 12.8008 7.40524 12.8008 5.27966C12.8008 3.91007 13.8932 2.7998 15.2408 2.7998C16.5884 2.7998 17.6808 3.91007 17.6808 5.27966Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.768 6.25263C23.768 7.83157 22.9621 9.41052 21.968 9.41052C20.9739 9.41052 20.168 7.83157 20.168 6.25263C20.168 5.23526 20.9739 4.41052 21.968 4.41052C22.9621 4.41052 23.768 5.23526 23.768 6.25263Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatarActivatedTeam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar--activatedTeam.25744a19959940359410f86fcfcc6837.svg";